import React from 'react';
import '../css/navbar.css'


const NavBar = () => {

  const getUserData = () => {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData) : null;
  };

  const logout = () => {
    localStorage.removeItem("user");
    window.location.href = '/';
  };

  const userData = getUserData();

  return (
    <header className="navbar">
      <a href="/" className="logo">Logs Uploader</a>
      <nav className="nav-links">
        <a href="/leaderboard">Leaderboard</a>
        {userData && <a href="/upload">Upload</a>}
        {userData && <a href="/friends">Friends</a>}
        {userData && <a href="/mylogs">My Logs</a>}
        {userData && <a href="/myrecap">My Recap (WIP)</a>}
      </nav>
      <div className="auth-buttons">
        {userData && 
          <div>
            <span>Signed In As </span>
            <span style={{ fontWeight: 'bold', color: '#BB86FC' }}>{userData.user}</span>
          </div>
        }
        {userData &&  <button onClick={logout} className="auth-button">Logout</button>}
        {!userData && <a href="/signin" className="signin-btn">Sign In</a>}
        {!userData && <a href="/signup" className="signup-btn">Sign Up</a>}
        <a href="/settings" className="settings-icon">⚙️</a>
      </div>
    </header>
  );
};

export default NavBar;
